import { render, staticRenderFns } from "./AppLayer.vue?vue&type=template&id=0022a9f0&scoped=true&"
import script from "./AppLayer.vue?vue&type=script&lang=ts&"
export * from "./AppLayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0022a9f0",
  null
  
)

export default component.exports